module.exports = __webpack_public_path__ + "img/twelve-logo.5f6a5308.svg";